<script setup lang="ts">
defineOptions({
  name: "403"
});
</script>

<template>
  <ExceptionBase type="403" />
</template>

<style scoped></style>
